"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTaxesFromOrder = exports.getPaymentMethodsForOrder = exports.getOrder = void 0;
var _utils = require("../utils");
var _paramKeys = _interopRequireDefault(require("./paramKeys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getOrder = exports.getOrder = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/orders/', params.orderNo],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getOrder'], ...(0, _utils.getCustomKeys)(params)];
    return [...getOrder.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getPaymentMethodsForOrder = exports.getPaymentMethodsForOrder = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/orders/', params.orderNo, '/payment-methods'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getPaymentMethodsForOrder'], ...(0, _utils.getCustomKeys)(params)];
    return [...getPaymentMethodsForOrder.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getTaxesFromOrder = exports.getTaxesFromOrder = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/orders/', params.orderNo, '/taxes'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getTaxesFromOrder'], ...(0, _utils.getCustomKeys)(params)];
    return [...getTaxesFromOrder.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};